const DEFAULT_TITLES = {
	tip: "TIP",
	warning: "WARNING",
	danger: "DANGER",
	info: "INFO",
	details: "Details",
} as const;

type ContainerType = keyof typeof DEFAULT_TITLES;

const CONTAINER_PATTERN = /^:::[ \t]*(tip|warning|danger|info|details)(?:[ \t]+(.*?))?[ \t]*\n([\s\S]*?)^:::[ \t]*$/gm;

/**
 * support サイト（VitePress）独自のカスタムコンテナ記法 `::: tip 〜 :::` を、
 * react-markdown（rehype-raw）で描画できる HTML に変換する。
 * 開始タグと本文の間に空行を挟むことで、本文は引き続き Markdown として解釈される。
 */
export const convertVitepressContainers = (markdown: string): string =>
	markdown.replace(CONTAINER_PATTERN, (_, type: ContainerType, customTitle: string | undefined, body: string) => {
		const title = customTitle || DEFAULT_TITLES[type];
		const content = body.trim();

		if (type === "details") {
			return `<details>\n<summary>${title}</summary>\n\n${content}\n\n</details>`;
		}
		return `<div class="custom-block ${type}">\n\n**${title}**\n\n${content}\n\n</div>`;
	});
